if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        // Hide immediately to ensure no space or layout shift
        this.style.display = 'none';
        this.removeAttribute('available');
      }

      fetchAvailability(variantId) {
        // Disabled to prevent unnecessary network requests and rendering
        return;
      }

      onClickRefreshList() {}

      update(variant) {
        this.removeAttribute('available');
        this.innerHTML = '';
        this.style.display = 'none';
      }

      renderError() {
        this.innerHTML = '';
        this.style.display = 'none';
      }

      renderPreview(sectionInnerHTML) {
        this.innerHTML = '';
        this.removeAttribute('available');
        this.style.display = 'none';
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();
        this.style.display = 'none';
      }

      handleBodyClick(evt) {}

      hide() {
        this.removeAttribute('open');
        this.style.display = 'none';
      }

      show(focusElement) {
        this.style.display = 'none';
      }
    }
  );
}